import { useSearchParams } from "react-router-dom";
import Seo from "@/components/Seo";
import StrategistChat from "@/components/StrategistChat";
import { useLang } from "@/context/LanguageContext";

export default function Strategist() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const initialQuestion = params.get("q") || undefined;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "Evony Strategist",
    applicationCategory: "GameApplication",
    operatingSystem: "Web",
    description: "AI-powered strategy companion for Evony: The King's Return with guides, generals, monsters and strategy answers backed by Evony Guide Wiki sources.",
    offers: { "@type": "Offer", price: "0", priceCurrency: "USD" },
  };

  return (
    <div className="es-page es-home" data-testid="page-strategist">
      <Seo
        title="Evony Strategist — AI Strategy Guide for Evony: The King's Return"
        description="Evony Strategist is an AI-powered companion for Evony: The King's Return with guides, generals, monsters, rankings and strategy answers backed by Evony Guide Wiki sources."
        path="/"
        jsonLd={jsonLd}
      />
      <header className="es-home-hero">
        <h1 className="es-display" data-testid="home-title">
          EVONY <span className="es-accent">STRATEGIST</span>
        </h1>
        <p className="es-home-tagline" data-testid="home-tagline">{t("brand.tagline")}</p>
      </header>
      <StrategistChat initialQuestion={initialQuestion} />
    </div>
  );
}
